import { ref, onMounted, onUnmounted } from "vue"

// by convention, composable function names start with "use"
export function useEnvironmentSettings() {
	const environmentName = import.meta.env.VITE_ENVIRONMENT_NAME.toString()

	switch (environmentName) {
		case "Development":
			return { backgroundColor: "#237f52", textColor: "White", environmentName } //green
		case "UAT":
			return { backgroundColor: "Yellow", textColor: "black", environmentName } //orange
		case "Demo":
			return { backgroundColor: "white", textColor: "rgb(0, 51, 98)", environmentName } //dark blue
		case "Training":
			return { backgroundColor: "darkviolet", textColor: "white", environmentName } //violet
		case "Production":
			return { backgroundColor: "red", textColor: "White", environmentName } //invisible
		default:
			return { backgroundColor: "rgb(113, 113, 113)", textColor: "white", environmentName: environmentName + " is not a valid environment name" } //grey
	}
}
